import React from "react";
import styled from "styled-components";
import { Form, Input, Row } from "antd";
import fontStyle from "src/styles/fontStyle";

const Notice = styled.span`
  margin-top: 5px;
  margin-left: 10px;
  color: ${({ theme }) => theme.colorNeutral500};
  ${fontStyle("14px", "22px")};
`;

const ErrorText = styled.div`
  margin-left: 135px;
  color: ${({ theme }) => theme.colorSuccess500};
`;

type Props = {
  error: string;
};

export default function CommonFormFields({ error }: Props) {
  return (
    <>
      <Form.Item shouldUpdate label="SKU(品號)" name="sku" labelAlign="left" rules={[{ required: true, message: "" }]}>
        <Input />
      </Form.Item>
      <ErrorText style={{ color: "#EC6922" }}>{error}</ErrorText>

      <Row>
        <Form.Item label="商品名稱" name="productName" labelAlign="left" rules={[{ required: true, message: "" }]}>
          <Input disabled />
        </Form.Item>
        <Notice>*輸入品號後自動帶入</Notice>
      </Row>

      <Row>
        <Form.Item label="成本" name="weightedCost" labelAlign="left">
          <Input disabled />
        </Form.Item>
        <Notice>*輸入品號後自動帶入</Notice>
      </Row>
    </>
  );
}
